import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=25a88650&"
import script from "./eventDetail.vue?vue&type=script&lang=js&"
export * from "./eventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports